<template>
    <section class="db">
        <template>
            <div class="container" style="width: 100%">
                <!-- header start  -->
                <header class="db-header ">
                    <div class="container" style="color: #fff;width: 1230px;z-index: 999">
                        <div style="float:left;font-size: 1.4rem;color: #ff912f">
                            <a style="float:left;font-size: 16px;color: #ff912f;text-decoration:none;" :href="userData.app_url"><span>NOBOOK化学实验测评</span></a>
                        </div>
                        <div style="float:left;margin:-13px 0 0 18%;height:47px;min-width: 300px;">
                            <span @click="switchTags(1)" :class="{'header-nav':true,activeNav:nav1}">实验库</span>
                            <span @click="switchTags(2)" :class="{'header-nav':true,activeNav:nav3}">
                                考试记录
                            </span>
                        </div>
                        <div class="user-info">
                            <div style="display: inline-block">
                                <a @click="showHelp" href="javascript:(0)" style="color:#fff;text-decoration:none;">
                                    <img src="/static/images/icon_help.png" alt="">
                                    帮助
                                </a>
                            </div>
                            <div style="display: inline-block;margin-right: 10px;"></div>
                            <span class="el-dropdown-link">
                                <img :src="user.avatar">
                            </span>
                            <el-popover
                                    ref="popover4"
                                    placement="bottom"
                                    width="100"
                                    trigger="click">
                                <div class="logInType">
                                    <div>
                                        <a
                                                style="cursor: pointer"
                                                @click="$router.push({ path: '/teachercenter', query: { plan:''}})" :to="{path:'/teachercenter'}">个人中心</a>
                                    </div>
                                    <!-- <div style="border-top: 1px solid #dbdbdb">
                                        <a href="javascript:" @click="getPacoage">切换地区</a>
                                    </div> -->
                                    <div style="border-top: 1px solid #dbdbdb">
                                        <a :href="GLOBAL.url.pact + '://passport.' + GLOBAL.url.path + '/logout?return_url='+nowHref">退出</a>
                                    </div>
                                </div>
                            </el-popover>
                            <span v-popover:popover4 style="cursor: pointer">{{user.nickname}}</span>
                        </div>
                    </div>
                </header>

                <!-- header end  -->

                <!-- body start  -->
                <div id="nbBody" style="width: 100%">
                    <router-view ref="routerView" v-on:center-data="getData"></router-view>
                </div>
                <!-- body end  -->

                <el-dialog title="" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="joinGuide" custom-class="vipDialog huiInput" width="580px">
                    <div style="height:380px;background-color: #fff;">
                        <span class="vipTitle">补全信息</span>
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                            <el-form-item label="您的身份" prop="type">
                                <el-radio-group v-model="ruleForm.user_type">
                                    <el-radio :label="2">教师</el-radio>
                                    <el-radio :label="1">学生</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="真实姓名" prop="nickname">
                                <el-input style="width: 276px" v-model="ruleForm.nickname"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" prop="phone">
                                <el-input style="width: 276px" v-model="ruleForm.phone"></el-input>
                            </el-form-item>
                            <el-form-item label="所在地区" prop="phone">
                                <nb-region @getRegionData="getRegionData"></nb-region>
                            </el-form-item>
                            <el-form-item v-if="ruleForm.user_type==2" label="所在学校" prop="">
                                <el-select
                                        style="float:left;width:50%"
                                        v-model="ruleForm.nbschool_id"
                                        filterable
                                        remote
                                        :disabled="enterSchool"
                                        reserve-keyword
                                        placeholder="支持拼音首字母和学校名称搜索 "
                                        :remote-method="seachSchool"
                                        :loading="loadingSchool">
                                    <el-option
                                            v-for="item in schoolSearchList"
                                            :key="item.id"
                                            :label="item.schoolname"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="getVip('ruleForm')" type="primary">保存</el-button>
                </div>
            </span>
                </el-dialog>

                <el-dialog title="" class="huiInput" :show-close="false" :visible.sync="succesDialog" width="420px">
                    <div  style="text-align:center">
                        <img src="/static/images/exam/icon_complet.png" alt=""><br>
                        <span>恭喜您成功领取15天VIP</span>
                        <div class="studentVip" v-if="ruleForm.type==2">
                            <span style="color: #868585;font-size:14px;">您还为加入班级，加入班级可体验更多功能</span><br>
                            <el-input style="width:210px;margin:10px 0;" v-model="classNum" placeholder="请输入班级编号"></el-input>
                            <br>
                            <span style="color: #868585;font-size:12px;">班级编号可向任课老师咨询</span><br>
                            <div style="margin-top:15px">
                                <el-button @click="inClass" type="primary">加入班级</el-button>
                                <span class="fr"
                                      @click="succesDialog=false"
                                      style="color: rgba(101, 101, 101, 0.7);font-size:14px;margin:15px 20px 0 0;cursor:pointer;">
                                    跳过</span>
                            </div>
                        </div>
                    </div>
                    <span v-if="ruleForm.type==1" slot="footer" class="dialog-footer" style="text-align: center">
                        <div>
                            <el-button @click="carryOut" type="primary">完成</el-button>
                        </div>
                     </span>
                </el-dialog>
                <nb-help ref="Nbhelp"></nb-help>
            </div>

            <!--<el-dialog title="请选择你所在的地区"-->
                       <!--:close-on-click-modal="false" :visible.sync="packageDialog" width="420px">-->
                <!--<el-select style="width:100%" v-model="packageData" clearable placeholder="请选择">-->
                    <!--<el-option-->
                            <!--v-for="item in packageList"-->
                            <!--:key="item.id"-->
                            <!--:label="item.name"-->
                            <!--:value="item.id">-->
                    <!--</el-option>-->
                <!--</el-select>-->
                <!--<div slot="footer" class="dialog-footer" style="text-align: center">-->
                    <!--<div>-->
                        <!--<el-button @click="areaChecked()" type="primary">确定</el-button>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</el-dialog>-->

            <div class="prompt" v-if="tryOut">
                当前页面为化学实验测评演示页面，如需体验全部功能请点击 <a href="/login">立即使用</a>
            </div>

            <!--<nb-pay></nb-pay>-->
        </template>
    </section>
</template>

<script>
    import{
        getuserinfo,
        saveuserinfo,
        joinclass,
        schoolList,
        selectprovince,
        getunfinishexamnum
    }from './api/exam_api.js';
    export default {
        data() {
            return {

                unfinish_num:0,
                loadingSchool:false,
                schoolSearchList:[],
                enterSchool:true,
                packageData:'',
                packageDialog:false,
                packageList:[],
                userData:{
                    app_url:'',
                    unfinish_num:''
                },
                tryOut:false,
                succesDialog:false,
                joinGuide:false,
                user:{
                    avatar: '/static/img/account/usericon.png',
                },
                nav1:true,
                nav2:false,
                nav3:false,
                ruleForm:{
                    user_type:2,
                    nickname:'',
                    phone:'',
                    nbschool_id:'',
                    province_id:'',
                },
                class_id:'',
                classNum:'',
                rules:{
                    user_type:[
                        { required: true, message: '请选择身份', trigger: 'blur' },
                    ],
                    nickname:[
                        {max:6 ,min:2 , required: true, message: '请输入2到6位真实姓名', trigger: 'blur' },
                    ],
                    phone:[
                        {max:11 , required: true, message: '请输入11位联系电话', trigger: 'blur' },
                    ],
                    nbschool_id:[
                        {required: true, message: '请选择学校', trigger: 'blur' },
                    ],
                    province_id:[
                        {required: true, message: '请选择套餐', trigger: 'blur' },
                    ],
                },
                regionData:{
                    ids:{},
                    names:{}
                },
                nowHref:''
            };
        },
        created() {
            this.activeMenu = this.$route.name;
            //  this.user = JSON.parse(localStorage.getItem('user'));
        },
        watch: {
            '$route'(to, from) {
                this.activeMenu = this.$route.name;
                //  this.user = JSON.parse(localStorage.getItem('user'));
            }
        },
        methods: {
            areaChecked(){
                selectprovince({province_id:this.packageData}).then((res)=>{
                    if(res.code==200){
                        location.reload();
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });
            },
            seachSchool(query){
                if(query){
                    this.newSchoolName=query;
                    let data={
                        provinceId:this.regionData.ids?this.regionData.ids.provinceValue:'',
                        cityId:this.regionData.ids?this.regionData.ids.cityValue:'',
                        districtId:this.regionData.ids?this.regionData.ids.areaValue:'',
                        schoolName:'',
                        pinYin:'',
                    }
                    this.loadingSchool=true;
                    let re = new RegExp("^[a-zA-Z]+$");
                    if(re.test(query)){
                        data.pinYin=query;
                    }else{
                        data.schoolName=query;
                    }
                    schoolList(data).then((res)=>{
                        if(res.code==200){
                            this.loadingSchool=false;
                            this.schoolSearchList=res.data.dataList;
                        }
                    });
                }
            },
            getRegionData($data,$name){
                if($data!=''){
                    this.enterSchool=false;
                }else{
                    this.enterSchool=true;
                }
                this.regionData.ids=$data;
                this.regionData.names=$name;
            },
            getPacoage(){
                this.packageDialog = true;
            },
            showHelp(){
                this.$refs.Nbhelp.dialogHelpShow();
            },
            carryOut(){
                this.succesDialog=false;
                location.reload();
            },
            inClass(){
                joinclass({class_code:this.classNum,pid:this.GLOBAL.pid}).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.succesDialog=false;
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });
            },
            switchTags($type){
                switch($type)
                {
                    case 1:
                        this.nav1=true;
                        this.nav3=false;
                        this.nav2=false;
                        this.$router.push({ path: '/experimentallibrary', query: { plan: 1 }});
                        break;
                    case 2:
                        this.nav1=false;
                        this.nav3=true;
                        this.nav2=false;
                        this.$router.push({ path: '/studentexancentre', query: { plan: 1 }});
                        break;
                    case 3:
                        this.nav1=false;
                        this.nav3=false;
                        this.nav2=true;
                        this.$router.push({ path: '/manageclass', query: { plan: 1 }});
                        break;
                    case 4:
                        this.nav1=false;
                        this.nav3=false;
                        this.nav2=true;
                        break;
                    case 5:
                        this.nav1=true;
                        this.nav3=false;
                        this.nav2=false;
                        break;
                }
            },
            getData(res){
              let _href=window.location.href;
              res = {data:{}};
              res.data.uinfo = this.GLOBAL.userInfo.userInfo;
              this.class_id = res.data.uinfo.classId;
              if(res.data.uinfo && res.data.uinfo.userId){
                this.userData=res.data.uinfo;
                this.joinGuide=false;
                this.user={
                  avatar: '/static/img/account/usericon.png',
                  nickname:res.data.uinfo.nickname,
                  personal:this.GLOBAL.url.pact+'://account.'+this.GLOBAL.url.path,
                  logIn:'/logout?return_url='+_href
                };
              }else{
                this.userData={
                  app_url:'',
                  unfinish_num:''
                }
                this.joinGuide=true
              }
              if(res.data.username=='examstudent'){
                this.tryOut=true;
              }
              //this.getNum();
            },
            getVip(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.ruleForm.pid = this.GLOBAL.pid;
                        this.ruleForm.location_p=this.regionData.ids.provinceValue;
                        this.ruleForm.location_c=this.regionData.ids.cityValue;
                        this.ruleForm.location_a=this.regionData.ids.areaValue;
                      this.ruleForm.pid = this.GLOBAL.pid;
                        saveuserinfo(this.ruleForm).then((res)=>{
                            if(res.code==200 || res.code == 0){
                                this.joinGuide=false;
                                this.succesDialog=true
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // getNum(){
            //     getunfinishexamnum({class_id:this.class_id,productid:this.GLOBAL.productId}).then((res)=>{
            //         if(res.code==200){
            //             this.unfinish_num=res.data.num;
            //         }
            //     });
            // }
        },
        mounted(){
            let timeSet=self.setInterval(()=>{
                // this.getNum();
            },30000);
            let _href=window.location.href;
            if(_href.indexOf('experimentallibrary')!=-1){
                this.switchTags(1);
            }else if(_href.indexOf('studentexancentre')!=-1){
                this.switchTags(2);
            }else if(_href.indexOf('manageclass')!=-1){
                this.switchTags(3);
            }else if(_href.indexOf('store')!=-1){
                this.switchTags(5);
            }else{
                this.switchTags(4);
            }
            this.getData();
            this.nowHref = location.href;
        }
    };
</script>

<style lang="scss">
    @import './styles/_variables.scss';
    .item{
        .el-badge__content{
            border: none;
        }
    }
    .prompt{
        position: fixed;
        background-color: #fdf6ec;
        color: #e6a23c;
        text-align:center;
        padding:8px;
        left: 0;
        bottom: 0;
        width:100%;
        a{
            color: #e6a23c;
            &:focus{
                color: #e6a23c;
            }
        }
    }
    .huiInput{
        input{
            background-color: rgba(0, 0, 0, 0.1);
            color: rgba(134, 133, 133, 0.8);

        }
    }
    .studentVip{
        height: 201px;
        background-color: #ebedf3;
        margin: 0 -20px -28px -20px;
    }
    .vipDialog{
        position: relative;
        .vipTitle{
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0px;
            letter-spacing: 0px;
            color: #868585;
            margin: 30px 0 30px 20px;
            display:inline-block;
        }
    }
    .logInType{
        text-align: center;
        div{
            padding: 10px;
            a{
                display:inline-block;
                font-size:16px;
                color: #949494;
                border: none;
                text-decoration:none;
                width: 100%;
                height: 100%;
                &:hover,&:link{
                    border: none;
                    text-decoration:none;
                }
            }
        }
    }
    .activeNav{
        background-color: #2f87ff;
    }
    .header-nav{
        padding-top:13px ;
        display: inline-block;
        width: 150px;
        text-align: center;
        font-size:20px;
        height:79%;
        cursor:pointer
    }
    .db-body{
        .el-menu-item{
            a{
                display: inline-block;
                width: 100%;
                height: 100%;

            }
        }
    }
    a:hover{
        text-decoration:none
    }
    .db-header a:hover{
        text-decoration:none;
        color: #fff;
    }
    .db {
        .el-dropdown-menu {
            margin-top: 20px;
        }
        // header
        .db-header {
            width: 100%;
            height: 50px;
            background: #2f313a;
            padding: 13px 20px;
            box-sizing: border-box;
            color: #ffffff;
            z-index: 99;
            position: fixed;
            left: 0;
            top: 0;

            .logo{
                font-size: 2.4rem;
            }

            .user-info {
                float: right;

                img {
                    width: 25px;
                    height: 25px;
                    vertical-align: -7px;
                    margin: 0 0 0 10px;
                    cursor: pointer;
                }
            }
        }

        // body
        .db-body {
            .switchPingtais{
                min-height: 100%;
                flex-grow: 0;
                width: 200px;
                z-index: 99;
                background-color: #EFF2F7;
            }
            // menu
            .db-menu-wrapper {
                position: fixed;
                left: 0;
                padding-top: 50px;
                height: 100%;
                overflow: auto;
                z-index: 98;

                .db-menu-bar {
                    min-height: 100%;
                    flex-grow: 0;
                    width: 200px;
                }
            }

            // content
            .db-content-wrapper {
                width: 100%;
                z-index: 97;
                box-sizing: border-box;
                margin: auto;
                padding: 50px 0 0 0;

                .db-content {
                    padding: 25px;

                    .db-content-inner {
                        padding: 30px 0px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/assets/js/Student.vue